<template>
  <div class="document-info">
    <div class="table-search">
      <a-form layout="inline">
        <a-row :gutter="12" class="searchRow">
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="文件名称" v-model="searchModel.name" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="上传人员" v-model="searchModel.uploader" />
          </a-col>
          <a-col :md="16" :sm="24" class="searchColBtn">
            <span class="table-page-search-submitButtons">
              <a-button class="btn" type="primary" @click="search">查询</a-button>
              <a-button class="btn btnMarginLeft_12" @click="clearSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      class="documentTable tableDataTabs"
      id="documentTable"
      bordered
      :pagination="pagination"
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :loading="table.loading"
      @change="handleTableChange">
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click.stop="() => handleDownload(record)">下载</a>
        <a-divider type="vertical" />
        <a href="javascript:;" @click.stop="() => handlePreview(record)">预览</a>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getEquipmentDocument } from '@/api/equipmentLedger'
export default {
  name: 'DocumentInfo',
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initTableData()
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            width: 50
          },
          {
            title: '文件名称',
            dataIndex: 'name'
          },
          {
            title: '文件分类',
            dataIndex: 'type'
          },
          {
            title: '上传人员',
            dataIndex: 'uploader'
            // width: 160
          },
          {
            title: '上传时间',
            dataIndex: 'uploadTime'
            // width: 180
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        loading: false
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 23,
        showSizeChanger: true,
        showQuickJumper: true
      },
      searchModel: {}
    }
  },
  methods: {
    initTableData () {
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchModel
      }
      console.log('params document_' + this.model.id, params)
      getEquipmentDocument(params).then(res => {
        if (res.status === 0) {
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        }
      })
    },
    handlePreview (record) {},
    handleDownload (record) {},
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initTableData()
    },
    search () {
      const model = { ...this.searchModel }
      if (model.name) {
        model.name = model.name.trim()
      }
      if (model.uploader) {
        model.uploader = model.uploader.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.initTableData()
    },
    clearSearch () {
      this.searchModel = {}
      this.initTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.document-info{
  .table-search{
    margin: 10px;
    .searchColBtn{
      .btn{
        margin-right: 10px;
      }
    }
  }
  .documentTable{
    margin-left: -1px;
    margin-right: -1px;

  }
}
/deep/ .ant-table-thead{
  height: 32px;
  & th{
    background: #E6ECF5;
  }
}
.tableDataTabs /deep/ .ant-table-body {
  border-left: 1px solid #DDDDDD;
}
.mb-10{
  margin-bottom: 10px;
}
</style>
